import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  Chip,
  Paper,
  Box,
  MenuItem,
  Button,
  FormControl,
  Select,
  Tabs,
  Tab,
  InputLabel,
  Divider,
  useTheme,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import apiConfigs from "../../config/config";
import history from "../../utils/HistoryUtils";
import AlertDialog from "../../components/Alert/AlertDialog";
import { useDispatch, useSelector } from "react-redux";
import Notification from "../../components/Notification/Notification";
import { cancelInvoice, changeShiftStatus, deleteBooking, delTimeSheetDoc } from "../../store/action";
import CandidatesList from "./CandidatesList";
import PublishIcon from "@material-ui/icons/Publish";
import axios from "axios";
import { Link } from "react-router-dom";
import { getSingleBooking } from "../../store/action/booking/bookingAction";
import RescheduleShift from "./RescheduleShift";
import Loading from "../../components/Loading/Loading";
import { GetApp, PictureAsPdf } from "@material-ui/icons";
import moment from "moment/moment";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main
  },
  desc: {
    fontWeight: 600,
  },
  inputLabel: {
    marginRight: theme.spacing(1),
  }
}));
const baseUrl = apiConfigs.API_URL + "uploads/timesheet/";
// "http://backendbooking.kanhasoftdev.com/public/uploads/timesheet/";

const DetailBooking = ({ match }) => {
  const tabList = ['VACANCY', 'BOOKED', 'CANCEL', 'PROVISIONAL', 'COMPLETED']
  const [deleteTimeSheetOpen, setDeleteTimeSheetOpen] = useState(false);
  const [timeSheetId, setTimeSheetId] = useState(false);
  const classes = useStyle();
  const dispatch = useDispatch();
  const booking_id = match.params.id;
  const [Id, setId] = useState(false);
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const [bookingDetail, setBookingDetail] = useState([]);
  const [initialData, setInitialData] = useState([])
  const [loading, setLoading] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [staffNotify, setStaffNotify] = useState(false);
  const [delTimeSheetNotify, setDelTimeSheetNotify] = useState(false);
  const [cancelInvoiceNotify, setCancelInvoiceNotify] = useState(false);
  const [bookingNotify, setBookingNotify] = useState(false);
  const [confirmBtn, setConfirmBtn] = useState(false);
  const [timesheetMsgError, setTimesheetError] = useState("");
  const [cancelInvoiceOpen, setCancelInvoiceOpen] = useState(false);
  const [searchingVal, setSearchingVal] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const theme = useTheme();

  const loginUserInfo = JSON.parse(window.localStorage.getItem("loginUserInfo"));
  if (localStorage.getItem('tabStatus') === undefined && localStorage.getItem('tabStatus') > 0) {
    localStorage.setItem('tabStatus', 1);
  }
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const { cancelInvoiceSuccess, cancelInvoiceError, deleteTimeSheetSuccess, deleteTimeSheetError,
    deleteBookingSuccess, deleteBookingError, shiftStatusSuccess
  } = useSelector((state) => state.booking);

  const [bookingStatus, setBookingStatus] = useState({
    booking_id: "",
    status: "",
    signee_detail: "",
  });

  useEffect(() => {
    if (bookingStatus.booking_id !== "") {
      dispatch(changeShiftStatus(bookingStatus));
      setBookingNotify(true);
      setTimeout(() => {
        getBookingDetail("", "");
      }, 4000);
    }
  }, [bookingStatus]);

  useEffect(() => {
    getBookingDetail("", "");
  }, []);

  if (
    localStorage.getItem("tabStatus") !== undefined &&
    activeIndex != localStorage.getItem("tabStatus")
  ) {
    setActiveIndex(localStorage.getItem("tabStatus"));
  }
  const upadateLink = () => {
    history.push(`update`);
  };

  const getBookingDetail = async (search, type, proximity) => {
    setLoading(true);
    try {
      dispatch(
        getSingleBooking(
          {
            booking_id,
            search,
            type,
            proximity
          },
          (result) => {
            setBookingDetail(result);
            setInitialData(result)

            setLoading(false);
          }
        )
      );
    } catch (error) {
      console.error("error.message", error.message);
      setLoading(false);
    }
  };



  const deleteBookingClose = () => {
    setDeleteOpen(false);
  };

  const deleteStaffItem = (id) => {
    setDeleteOpen(true);
    setId(id);
  };
  const alertResponse = (id) => {
    dispatch(deleteBooking(id));
    setStaffNotify(true);
  };
  const backPage = () => {
    history.goBack(-2);
  };

  const backToPrevPage = (tabIndex) => {
    localStorage.setItem('tabStatus', tabIndex);
    setActiveIndex(tabIndex);
    localStorage.setItem('pageNo', 1);
    history.goBack(-1);
  };

  const handleClose = (action) => {
    setOpen(false);
  };

  //added this signee_detail for updating booking matches status when we cancel any booking 
  const handleBookingStatus = (event, id, signee_detail) => {
    setBookingStatus({
      ...bookingStatus,
      [event.target.name]: event.target.value,
      booking_id: id,
      signee_detail: signee_detail //Done by preet paunikar
    });
  };



  const setTimesheet = (e) => {
    setLoading(true);
    const pic = e.target.files[0];
    let formData = new FormData();
    formData.append("timesheet", pic);
    formData.append("booking_id", booking_id);
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    axios
      .post(
        `${apiConfigs.API_URL}api/organization/upload-timesheet`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        const dataItem = response.data;
        if (dataItem && dataItem.status === true) {
          // window.location.reload();
          getBookingDetail("", "");
          setTimesheetError(dataItem);
          setLoading(false);
        } else {
          setTimesheetError(dataItem);
        }
      })
      .catch((error) => {
        setTimesheetError("Sorry timesheet upload failed");
      });
  };
  const downloadTimeSheet = async () => {
    setLoading(true);
    const getToken = localStorage.getItem("token")
      ? localStorage.getItem("token").replace(/['"]+/g, "")
      : "";
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/download-timesheet/${booking_id}`,
        {
          headers: {
            Authorization: getToken ? `Bearer ${getToken}` : "",
          },
          responseType: "blob",
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        const pieces = `${baseUrl}${bookingDetail?.data?.timesheet}`.split("/");
        const fileName = pieces[pieces.length - 1]
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        setLoading(false);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const deleteTimeSheet = (id) => {
    setDeleteTimeSheetOpen(true);
    setTimeSheetId(id);
  };

  const deleteTimeSheetClose = () => {
    setDeleteTimeSheetOpen(false);
  };

  const deleteTimeSheetResponse = (id) => {
    dispatch(delTimeSheetDoc(id));
    setDelTimeSheetNotify(true);
  };

  const cancelInvoiceBooking = (id) => {
    setCancelInvoiceOpen(true);
    setId(id);
  };

  const cancelInvoiceClose = () => {
    setCancelInvoiceOpen(false);
  };

  const cancelInvoiceResponse = (id) => {
    dispatch(cancelInvoice(id));
    setCancelInvoiceNotify(true);
  };

  const downloadCreditNotes = async () => {
    setLoading(true);
    let fileName = (bookingDetail?.data?.invoice_number) ? "CREDIT NOTES" + bookingDetail?.data?.invoice_number + ".pdf" : "CREDIT NOTES" + bookingDetail?.data?.name + ".pdf";
    const getToken = localStorage.getItem("token")
      ? localStorage.getItem("token").replace(/['"]+/g, "")
      : "";
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/generate-credit-notes/${booking_id}`,
        {
          headers: {
            Authorization: getToken ? `Bearer ${getToken}` : "",
          },
          responseType: "blob",
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        setLoading(false);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const downloadPdf = async () => {
    setLoading(true);
    let fileName = (bookingDetail?.data?.invoice_number) ? bookingDetail?.data?.invoice_number + ".pdf" : bookingDetail?.data?.name + ".pdf";
    const getToken = localStorage.getItem("token")
      ? localStorage.getItem("token").replace(/['"]+/g, "")
      : "";
    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/generate-invoice/${booking_id}`,
        {
          headers: {
            Authorization: getToken ? `Bearer ${getToken}` : "",
          },
          responseType: "blob",
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        setLoading(false);
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  let userRole = bookingDetail?.data?.user_role;
  let loggedInRole = bookingDetail?.data?.loggedin_role;
  // userRole = userRole && userRole.replace(/['"]+/g, ""); old code 
  userRole = loggedInRole;
  loggedInRole = loggedInRole && loggedInRole.replace(/['"]+/g, "");
  const originalDate = bookingDetail?.data?.invoice_date || null;
  let newdate;
  if (originalDate) {
    const parts = originalDate.split(" ");
    const datePart = parts[0];
    const timePart = parts[1];
    const dateParts = datePart.split("-");
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    newdate = `${day}-${month}-${year} ${timePart}`;
  }
  let signeeId = "";
  if (bookingDetail?.data?.confirmed) {
    signeeId = bookingDetail?.data?.confirmed.map(item => item.signeeId);
  }
  return (
    <>
      {loading && <Loading open={loading} />}

      {staffNotify && deleteBookingSuccess?.message && (
        <Notification data={deleteBookingSuccess?.message} status="success" />
      )}

      {staffNotify && deleteBookingError?.message && (
        <Notification data={deleteBookingError?.message} status="error" />
      )}

      {delTimeSheetNotify && deleteTimeSheetSuccess?.message && (
        <Notification data={deleteTimeSheetSuccess?.message} status="success" />
      )}

      {delTimeSheetNotify && deleteTimeSheetError?.message && (
        <Notification data={deleteTimeSheetError?.message} status="error" />
      )}

      {cancelInvoiceNotify && cancelInvoiceSuccess?.message && (
        <Notification data={cancelInvoiceSuccess?.message} status="success" />
      )}

      {cancelInvoiceNotify && cancelInvoiceError?.message && (
        <Notification data={cancelInvoiceError?.message} status="error" />
      )}

      {bookingNotify && shiftStatusSuccess?.message && (
        <Notification
          data={shiftStatusSuccess?.message}
          status={shiftStatusSuccess?.status === true ? "success" : "error"}
        />
      )}

      {timesheetMsgError && timesheetMsgError?.message && (
        <Notification
          data={timesheetMsgError?.message}
          status={timesheetMsgError?.status == true ? "success" : "error"}
        />
      )}

      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        {/* Tabs - will take up remaining space */}
        <Tabs
          value={Math.abs(activeIndex)}
          onChange={(e, index) => backToPrevPage(index)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          style={{ background: theme.palette.background.drawer }}
        >
          {tabList.map((list, index) => (
            <Tab
              key={index + 888}
              label={list.toLowerCase()}
              style={{ textTransform: "capitalize" }}
            />
          ))}
        </Tabs>

        <Box display="flex" alignItems="center">
          <InputLabel className={classes.inputLabel}>Booking Status: </InputLabel>
          <FormControl variant="outlined" style={{
            marginRight: 10,
            width: 190,
            borderRadius: "20px",
            // "& .MuiOutlinedInput-root": {
            // },
          }}>
            <Select
              value={bookingDetail?.data?.status || ""}
              name="status"
              onChange={(e) => handleBookingStatus(e, bookingDetail?.data?.id, signeeId)}
              disabled={staffDetail === "Finance" || bookingDetail?.data?.status === "CANCEL"}
            >
              {bookingDetail?.data?.status === "CREATED" && (
                <MenuItem value="CREATED" disabled>Created</MenuItem>
              )}

              {bookingDetail?.data?.status !== "CANCEL" && (
                <MenuItem value="CONFIRMED">Confirmed</MenuItem>
              )}

              {bookingDetail?.data?.status === "CREDIT NOTES" && (
                <MenuItem value="CREDIT NOTES">Credit Notes</MenuItem>
              )}

              {bookingDetail?.data?.timesheet ? (
                <MenuItem value="CANCEL">Cancel</MenuItem>
              ) : (
                <MenuItem value="CANCEL" disabled>Cancel</MenuItem>
              )}
            </Select>
          </FormControl>

          <Button
            variant="contained"
            color="secondary"
            startIcon={<GetApp />}
            disabled={
              !(
                bookingDetail?.data?.is_past &&
                ["Admin", "Finance", "ORGANIZATION", "SUPERADMIN"].includes(userRole) &&
                bookingDetail?.data?.status !== "CREDIT NOTES" &&
                bookingDetail?.data?.timesheet
              )
            }
            onClick={downloadPdf}
          >
            Generate Invoice
          </Button>
        </Box>
      </Box>

      <Paper className={classes.root} elevation={3}>
        <Typography variant="h6" >Booking Details</Typography>
        <Divider />
        <Grid container spacing={2} mt={1}>
          {[
            ["Reference ID", bookingDetail?.data?.reference_id],
            ["Customer Name", bookingDetail?.data?.name],
            ["Site Name", bookingDetail?.data?.hospital_name],
            ["Ward Name", bookingDetail?.data?.ward_name],
            ["Grade", bookingDetail?.data?.grade_name],
            ["Booking Reference", bookingDetail?.data?.booking_reference],
            ["Date", moment(bookingDetail?.data?.date).format("DD-MMM-yyyy")],
            ["Shift Time", `${bookingDetail?.data?.start_time} - ${bookingDetail?.data?.end_time}`],
            ["Break", `${bookingDetail?.data?.break} Minutes`],
            ["Booking Type", bookingDetail?.data?.booking_type],
            ["Purchase Order", bookingDetail?.data?.purchase_order],
          ].map(([label, value], i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Typography variant="body2" style={{ color: theme.palette.listItem }}>{label}</Typography>
              <Typography variant="body1" className={classes.desc}>{value || "-"}</Typography>
            </Grid>
          ))}

          {/* Speciality Chips */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="body2" style={{ color: theme.palette.listItem }}>Speciality</Typography>
            <Box display="flex" flexWrap="wrap" gap={1} mt={0.5}>
              {bookingDetail?.data?.speciality?.map((s, idx) => (
                <Chip key={idx} label={s.speciality_name} size="small" color="primary" />
              ))}
            </Box>
          </Grid>

          {bookingDetail?.data?.invoice_date && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" style={{ color: theme.palette.listItem }}>Invoice Date</Typography>
              <Typography variant="body1" className={classes.desc}>{newdate}</Typography>
            </Grid>
          )}

          {bookingDetail?.data?.invoice_number && (
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="body2" style={{ color: theme.palette.listItem }}>Invoice Number</Typography>
              <Typography variant="body1" className={classes.desc}>{bookingDetail?.data?.invoice_number}</Typography>
            </Grid>
          )}

          {/* Amount section */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom style={{ color: theme.palette.listItem }}>Amount</Typography>
            <Divider />
          </Grid>

          <Grid container spacing={2} sx={{ mb: 3 }}>
            {[
              ["NON AWR PAYE", bookingDetail?.data?.non_awr_paye_payable],
              ["AWR PAYE", bookingDetail?.data?.payable],
              ["NON AWR UMBRELLA", bookingDetail?.data?.non_awr_umbrella_payable],
              ["AWR UMBRELLA", bookingDetail?.data?.awr_umbrella_payable],
              ["Chargeable Amount Applied", bookingDetail?.data?.chargeable],
            ].map(([label, value], i) => (
              <Grid item xs={12} sm={6} md={2} key={i}>
                <Typography variant="subtitle2" style={{ color: theme.palette.listItem }}>{label}</Typography>
                <Typography variant="body1" fontWeight="bold">{value || "-"}</Typography>
              </Grid>
            ))}
          </Grid>

          {bookingDetail?.data?.is_past &&
            (["Admin", "Finance"].includes(bookingDetail?.data?.user_role) ||
              ["ORGANIZATION", "SUPERADMIN"].includes(bookingDetail?.data?.loggedin_role)) &&
            bookingDetail?.data?.status !== "CREATED" &&
            (bookingDetail?.data?.timesheet == null || bookingDetail?.data?.timesheet === "" ||
              ["CONFIRMED", "CREDIT NOTES"].includes(bookingDetail?.data?.status)) && (
              <Grid item xs={12}>
                <Typography variant="subtitle2">Timesheet:</Typography>
                <Box style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "500px" }} mt={1}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<PublishIcon />}
                    color="primary"
                  >
                    Upload
                    <input
                      key="timesheet-upload"
                      type="file"
                      accept="image/*,.pdf"
                      multiple
                      hidden
                      onChange={setTimesheet}
                    />
                  </Button>

                  {bookingDetail?.data?.timesheet && (
                    <>
                      <Button
                        variant="outlined"
                        startIcon={<GetApp />}
                        color="secondary"
                        onClick={downloadTimeSheet}
                      >
                        Download
                      </Button>

                      <Button
                        variant="outlined"
                        startIcon={<PictureAsPdf />}
                        color="secondary"
                        component={Link}
                        to={`${baseUrl}${bookingDetail?.data?.timesheet}`}
                        target="_blank"
                      >
                        View PDF
                      </Button>

                      {/* Delete timesheet */}
                      <Button
                        variant="outlined"
                        startIcon={<DeleteIcon />}
                        color="error"
                        onClick={() => deleteTimeSheet(bookingDetail?.data?.id)}
                      >
                        Delete
                      </Button>
                    </>
                  )}
                </Box>
              </Grid>
            )}

        </Grid>

        {/* Action section */}
        <Box display="flex" justifyContent="flex-end" style={{ gap: "8px" }} mt={1}>
          <Button color="primary" variant="outlined" onClick={backPage}>Back</Button>

          {bookingDetail?.data?.invoice_number &&
            (staffDetail === "Admin" || loginUserInfo?.role === "ORGANIZATION") &&
            bookingDetail?.data?.status === "CONFIRMED" && (
              <Button variant="contained" color="secondary" onClick={() => cancelInvoiceBooking(bookingDetail?.data?.id)}>
                Cancel Invoice
              </Button>
            )}

          {(userRole === "Admin" || userRole === "Finance" || loggedInRole === "ORGANIZATION" || loggedInRole === "SUPERADMIN") &&
            bookingDetail?.data?.status === "CREDIT NOTES" && (
              <Button startIcon={<GetApp />} onClick={downloadCreditNotes} color="primary" variant="outlined">
                CREDIT NOTES {bookingDetail?.data?.invoice_number}.pdf
              </Button>
            )}

          {(bookingDetail?.data?.status === "CREATED" || bookingDetail?.data?.custom_status == "PROVISIONAL") &&
            (((loginUserInfo?.role === "STAFF" && loginUserInfo?.permissions?.some(p => p.toLowerCase() === "bookings-update")) ||
              (loginUserInfo?.role !== "STAFF"))) && (
              <Button variant="contained" color="primary" onClick={upadateLink} >
                <EditIcon className="mr-2" /> Edit
              </Button>
            )}

          {staffDetail !== "Finance" && bookingDetail?.data?.status === "CANCEL" && (
            <Button variant="contained" color="secondary" onClick={handleClickOpen}>
              Reschedule Shift
            </Button>
          )}

          {(staffDetail === "Admin" || loginUserInfo?.role === "ORGANIZATION" ||
            (loginUserInfo?.role === "STAFF" && loginUserInfo?.permissions?.some(p => p.toLowerCase() === "bookings-delete")) ||
            (loginUserInfo?.role !== "STAFF")) && bookingDetail?.data?.status === "CREATED" && (
              <Button variant="contained" color="secondary" onClick={(e) => deleteStaffItem(bookingDetail?.data?.id)}>
                <DeleteIcon className="mr-2" /> Delete
              </Button>
            )}
        </Box>

      </Paper>

      <RescheduleShift open={open} id={bookingDetail?.data?.id} handleClose={handleClose} />

      {bookingDetail?.data?.status !== "CANCEL" && (
        <CandidatesList
          bookingDetail={bookingDetail}
          booking_id={booking_id}
          getBookingDetail={getBookingDetail}
          setConfirmBtn={setConfirmBtn}
          setBookingDetail={setBookingDetail}
          initialData={initialData}
          searchingVal={searchingVal}
          setSearchingVal={setSearchingVal}
          actionType='view'
        />
      )}

      <AlertDialog
        id={Id}
        open={deleteOpen}
        close={deleteBookingClose}
        response={alertResponse}
        title="Delete Booking"
        description="Are you sure you want to delete?"
        buttonName="Delete"
      />

      <AlertDialog
        id={timeSheetId}
        open={deleteTimeSheetOpen}
        close={deleteTimeSheetClose}
        response={deleteTimeSheetResponse}
        title="Delete Timesheet"
        description="Are you sure you want to delete?"
        buttonName="Delete"
      />

      <AlertDialog
        id={Id}
        open={cancelInvoiceOpen}
        close={cancelInvoiceClose}
        response={cancelInvoiceResponse}
        title="Cancel Invoice"
        description="Are you sure you want to cancel invoice?"
        buttonName="Yes"
      />

    </>
  );
};

export default DetailBooking;
